import t from "@/lang/lang";
import { formatDateTime } from "@/shared/lib/utilities/date";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { CompanySelect } from "@/services/backend/company/components/company-select";
import { CustomerSelect } from "@/services/backend/customers/components/customer-select";
import {
  OutboxAuthorizationReference,
  OutboxBase,
  OutboxCustomerReference,
} from "../types/outbox";
import { TextInputField } from "@/shared/components/field/input-field";
import { Field, FieldLabel } from "@/shared/components/ui/field";

export function OutboxBaseCard({
  outboxBase,
  onOutboxBaseChange,
  disabled,
}: {
  outboxBase: OutboxBase &
    OutboxAuthorizationReference &
    OutboxCustomerReference;
  onOutboxBaseChange: (
    outboxBase: OutboxBase &
      OutboxAuthorizationReference &
      OutboxCustomerReference,
  ) => void;
  disabled?: boolean;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Basisdaten")}</CardTitle>
        <CardDescription>{t("Status der Übermittlung.")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 md:grid-cols-3">
          <TextInputField
            label={t("Status")}
            text={outboxBase.outboxStatus}
            onTextChange={() => null}
            errors={[]}
            disabled
          />
          <TextInputField
            label={t("Erstellt am")}
            text={formatDateTime(outboxBase.outboxCreatedAt)}
            onTextChange={() => null}
            errors={[]}
            disabled
          />
          <TextInputField
            label={t("Geändert am")}
            text={formatDateTime(outboxBase.outboxUpdatedAt)}
            onTextChange={() => null}
            errors={[]}
            disabled
          />
          <Field>
            <FieldLabel>{t("Unternehmen")}</FieldLabel>
            <CompanySelect
              companyId={outboxBase.outboxCompanyId}
              onCompanyIdChange={(outboxCompanyId) => {
                onOutboxBaseChange({
                  ...outboxBase,
                  outboxCompanyId,
                });
              }}
              disabled={disabled}
            />
          </Field>
          <Field className="col-span-2 grid min-w-0 content-start gap-1.5">
            <FieldLabel>{t("Kunde")}</FieldLabel>
            <CustomerSelect
              value={outboxBase.outboxCustomerId}
              onValueChange={(outboxCustomerId) => {
                onOutboxBaseChange({
                  ...outboxBase,
                  outboxCustomerId,
                });
              }}
              disabled={disabled}
            />
          </Field>
        </div>
      </CardContent>
    </Card>
  );
}
